var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "version_page"
  }, [_vm._l(_vm.list, function (item) {
    return _c('Content', {
      key: item.id,
      attrs: {
        "data": item
      }
    });
  }), _vm.showNext ? _c('div', {
    staticClass: "next"
  }, [_c('a', {
    on: {
      "click": _vm.onChangeNextpage
    }
  }, [_vm._v($t("btgr63", "下一篇"))]), _c('h2', [_vm._v($t("dev07i4", "更新日志"))])]) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };